'use client';

import { c as _c } from "react/compiler-runtime";
import { parseAsInteger, useQueryState } from 'nuqs';
import { useTranslation } from 'react-i18next';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { trackClick } from '@sola/tracking/lib/analytics/events.ts';
export type StepperCompactProps = {
  items?: Array<FlexibleContentProps>;
};
export const StepperCompact: React.FC<StepperCompactProps> = t0 => {
  const $ = _c(6);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsInteger.withDefault(0);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [activeIndex, setActiveIndex] = useQueryState("step", t1);
  const {
    t
  } = useTranslation("help-me");
  let t2;
  if ($[1] !== activeIndex || $[2] !== items || $[3] !== setActiveIndex || $[4] !== t) {
    t2 = items && items.length > 0 && <div className="StepperTabbed__list--mobile flex flex-row align-center justify-between flex-1 mb-comfy-xs mt-comfy-sm"><button type="button" onClick={() => {
        setActiveIndex(Math.max(activeIndex - 1, 0));
        trackClick("Skip", undefined, "Stepper__mobile");
      }}>{activeIndex > 0 && <ArkIcon iconName="arrow-left" aria-label={t("pagination.back")} />}</button><div className="flex flex-col items-center"><span className="label-potent label-lg">{t("pagination.select", {
            attribute: `${items[activeIndex].title}`
          })}</span><span className="label-moderate label-sm">{t("pagination.stepOfSteps", {
            step: `${activeIndex + 1}`,
            total: `${items.length}`
          })}</span></div><button type="button" onClick={() => {
        setActiveIndex(Math.min(activeIndex + 1, items.length));
        trackClick("Skip", undefined, "Stepper__mobile");
      }}>{activeIndex < 4 && <ArkIcon iconName="arrow-right" aria-label={t("pagination.next")} />}</button></div>;
    $[1] = activeIndex;
    $[2] = items;
    $[3] = setActiveIndex;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};